import { announce } from "@/lib/a11y/announce";

type AlertFn = (message: string, options?: { title?: string }) => Promise<true>;

let alertImpl: AlertFn | null = null;
let lastMessage: string | null = null;

/** Wird einmalig von <DialogProvider> registriert (siehe useEffect dort). */
export function registerGlobalAlert(fn: AlertFn | null): void {
  alertImpl = fn;
}

/**
 * Ersatz für den window-"cleverfleet:api-error"-Listener aus src/app.js:
 * Hintergrund-Fehler (z. B. eine fehlgeschlagene Autosave-Anfrage, die niemand
 * awaitet) bekommen trotzdem einen Hinweisdialog, dedupliziert auf die letzte
 * Nachricht statt bei jedem Fehlschlag erneut zu unterbrechen.
 */
export function notifyBackgroundError(message: string): void {
  if (!alertImpl || message === lastMessage) return;
  lastMessage = message;
  announce(message);
  void alertImpl(`Serververbindung fehlgeschlagen: ${message}`, { title: "Serververbindung" }).finally(() => {
    lastMessage = null;
  });
}
